export const headerClass = ['/booking-ride']
export const footerRemove = ['/booking-ride']